import { useContext, useMemo } from 'react';
import { AppContext } from 'views/App/context';

export default function useHasAccreditationSolution(organizationId?: string, manualLevel?: string): boolean {
  const { hasPermission, currentOrganizationId, hasAppPermission } = useContext(AppContext);
  const orgId = organizationId ?? currentOrganizationId ?? '';
  const normalizedLevel = (manualLevel ?? '').trim().toUpperCase();
  return useMemo(
    () =>
      hasPermission('awbEssentials', orgId) ||
      hasPermission('awbPremium', orgId) ||
      (['JURISDICTION', 'GLOBAL'].includes(normalizedLevel) && hasAppPermission('lexipolAccreditationManagerActions')),
    [hasPermission, orgId, normalizedLevel, hasAppPermission],
  );
}
